import { __assign, __extends } from "tslib";
import React, { Component } from "react";
import ToastContainer, { positions, durations } from "./ToastContainer";
var PnmacToaster = /** @class */function (_super) {
  __extends(PnmacToaster, _super);
  function PnmacToaster() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._toast = null;
    return _this;
  }
  PnmacToaster.prototype.render = function () {
    return /*#__PURE__*/React.createElement("div", {
      "data-testid": "toastContainer"
    }, /*#__PURE__*/React.createElement(ToastContainer, __assign({
      visible: true
    }, this.props), this.props.children));
  };
  PnmacToaster.positions = positions;
  PnmacToaster.durations = durations;
  PnmacToaster.show = function (message, options) {
    if (options === void 0) {
      options = {
        position: positions.BOTTOM,
        duration: durations.SHORT
      };
    }
    return /*#__PURE__*/React.createElement(ToastContainer, __assign({}, options, {
      visible: true
    }), message);
  };
  PnmacToaster.hide = function (toast) {
    toast.destroy();
  };
  return PnmacToaster;
}(Component);
PnmacToaster.propTypes = ToastContainer.propTypes;
export default PnmacToaster;